import { Space } from '~/packages/variable/spaceTime.types'
import enumerated from '../enumerated'
import number from '../number'
import object from '../object'
import string from '../string'
import { InferNative } from '../type'
import { feature, polygon } from './geoJson'

export const delimitationType = enumerated({
  neighborhood: 'Bairro',
  street: 'Rua',
  city: 'Município',
  microRegion: 'Microrregião',
  mesoRegion: 'Mesorregião',
  state: 'Estado',
  macroRegion: 'Macrorregião',
  country: 'País',
  custom: 'Personalizado',
})

export const childrenType = enumerated({
  neighborhood: 'Bairro',
  street: 'Rua',
  city: 'Município',
  microRegion: 'Microrregião',
  mesoRegion: 'Mesorregião',
  state: 'Estado',
  macroRegion: 'Macrorregião',
  country: 'País',
  custom: 'Personalizado',
  item: 'Item',
})

export const childrenItemView = enumerated({
  heatmap: 'Mapa de calor',
  cluster: 'Agrupamento',
  marker: 'Marcador',
})

export function spaceForPoint() {
  return object({
    delimitationType: delimitationType.isOptional(),
    delimitationId: number().isOptional(),
    delimitationCustom: feature(polygon()).isOptional(),
    delimitationTitle: string().isOptional(),
    childrenType: childrenType.isOptional(),
    childrenKey: string().isOptional(),
    childrenItemView: childrenItemView.isOptional(),
    childrenH3Resolution: number().isOptional(),
  })
}

export type SpaceForPoint = InferNative<ReturnType<typeof spaceForPoint>>
